<template>
  <footer class="c-footer o-section--wide">
    <div class="c-footer__inner o-section__container">
      <div class="c-footer__top">
        <my-scroll class="c-footer__button o-link--round">
          <span class="c-footer__button__inner">
            <svg class="icon icon-up-arrow-large"><use xlink:href="#icon-up-arrow-large"></use></svg>
          </span>
          <span class="c-footer__button__text">Back to top</span>
        </my-scroll>
      </div>
      <div class="c-footer__bottom">
        <p class="c-footer__main"><a href="http://www.ukpowernetworks.co.uk/" class="o-icon-link"><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg><span>Go to main site</span></a></p>
        <p class="c-footer__title">UK Power Networks Annual Review 2016/17</p>
        <ul class="c-footer__links">
          <li class="c-footer__item"><a href="http://www.ukpowernetworks.co.uk/internet/en/privacy-policy/" class="c-footer__link">Privacy policy</a></li>
          <li class="c-footer__item"><a href="http://www.ukpowernetworks.co.uk/internet/en/terms-and-conditions/" class="c-footer__link">Terms &amp; conditions</a></li>
          <li class="c-footer__item"><a href="http://www.ukpowernetworks.co.uk/internet/en/cookie-policy/" class="c-footer__link">Cookie policy</a></li>
          <li class="c-footer__item"><a href="http://www.ukpowernetworks.co.uk/internet/en/contact-us/" class="c-footer__link">Contact</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import MyScroll from '@/components/standard/my-scroll'
// import { IconUpArrowLarge, IconLeftArrow } from '@/components/standard/my-icons'

export default {
  name: 'my-footer',
  components: {
    MyScroll
    // IconUpArrowLarge,
    // IconLeftArrow
  }
}
</script>



// WEBPACK FOOTER //
// MyFooter.vue?53088e84